// extracted by mini-css-extract-plugin
export default {"statsBox":"StatBox_statsBox__kVFK4","with-margin":"StatBox_with-margin__EXFrf","withMargin":"StatBox_withMargin__0x+5i"};